module.exports = __webpack_public_path__ + "img/commentcross.74fc30ca.svg";